/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  no-script-url
*/
export const TOP_BAR_V2_EXPERIMENT_LINK_DATA = [
  {
    url: '/api',
    text: 'API',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: '/api/documentation',
          text: 'Documentation',
        },
        {
          url: '/api/features',
          text: 'Features',
        },
        {
          url: '/api/libraries',
          text: 'Libraries',
        },
        {
          url: '/api/pricing',
          text: 'Pricing',
        },
        {
          url: '/api/reference',
          text: 'API Help',
        },
        {
          url: '/terms',
          text: 'API Terms',
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
  {
    url: 'javascript:;',
    text: 'Solutions',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: 'https://www.hellosign.com/solutions/insurance',
          text: 'Insurance',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/solutions/fintech',
          text: 'Fintech',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/solutions/real-estate-tech',
          text: 'Real Estate Tech',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/use-case/helloworks-onboarding',
          text: 'Onboarding',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/solutions/marketplaces',
          text: 'On-Demand Marketplaces',
          options: {
            target: '_blank',
          },
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
  {
    url: '/integrations',
    text: 'Integrations',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: 'https://www.hellosign.com/integrations/gmail',
          text: 'Gmail',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/integrations/google-docs',
          text: 'Google Docs',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/integrations/salesforce',
          text: 'Salesforce',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/integrations/dropbox',
          text: 'Dropbox',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/integrations/oracle',
          text: 'Oracle',
          options: {
            target: '_blank',
          },
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
  {
    url: 'javascript:;',
    text: 'Customers',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: 'https://www.hellosign.com/customers/instacart',
          text: 'Instacart',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/fountain',
          text: 'Fountain',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/climb-credit',
          text: 'Climb Credit',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/listingspark',
          text: 'ListingSpark',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/simplyinsured',
          text: 'Simply Insured',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/rvshare',
          text: 'RVShare',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/trxade',
          text: 'Trxade',
          options: {
            target: '_blank',
          },
        }, {
          url: 'https://www.hellosign.com/customers/vehiculum',
          text: 'Vehiculum',
          options: {
            target: '_blank',
          },
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
  {
    url: 'javascript:;',
    text: 'Pricing',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: '/info/pricing',
          text: 'HelloSign',
        },
        {
          url: '/api/pricing',
          text: 'HelloSign API',
        },
        {
          url: '%HF_PRICING_URL%',
          text: 'HelloFax',
        },
        {
          url: 'https://www.hellosign.com/products/helloworks-pricing',
          text: 'HelloWorks',
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
  {
    url: 'javascript:;',
    text: 'Products',
    options: {
      class: 'm-link-list--link-break-1',
      container_class: 'external-top-bar',
      sub_menu_items: [
        {
          url: 'https://www.hellosign.com/features',
          text: 'HelloSign',
          options: {
            target: '_blank',
          },
        },
        {
          url: ' https://www.hellosign.com/enterprise',
          text: 'HelloSign Enterprise',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/api',
          text: 'Hellosign API',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/integrations/salesforce',
          text: 'HelloSign for Salesforce',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/products/hellofax',
          text: 'HelloFax',
          options: {
            target: '_blank',
          },
        },
        {
          url: 'https://www.hellosign.com/products/helloworks',
          text: 'HelloWorks',
          options: {
            target: '_blank',
          },
        },
      ],
      sub_menu_class: 'external-top-bar',
      sub_menu_lock_to_parent: true,
      show_menu_drop_down_arrow: true,
    },
  },
];

export const TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD = 1075; // pixels

export const TOP_BAR_V2_EXPERIMENT_COOKIE_NAME = 'hs_experiment_top_bar_v2'; // Used for analytics
export const TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE = 'top_bar_v2_enabled'; // Used for analytics
export const TOP_BAR_V2_EXPERIMENT_NAME = 'top_bar_v2_enabled';
